import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { SelectionModel } from '@angular/cdk/collections';
import { CurrencyPipe, formatDate } from '@angular/common';
import { MatSort, MatPaginator, MatTableDataSource } from '@angular/material';
import { AppConfig, ExcelService } from '../_helpers/index';
import { Router, ActivatedRoute } from '@angular/router';
import { SettlementProcessService } from '../_services/settlementProcess.service';
import * as moment from 'moment';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { ExcelDateConvertService } from '../_services';
import { BatchProcessUrls } from '../_enums/urls';
import { Subscription } from 'rxjs';
import { AccountTypeOptions } from '../sharedcomp/constans/routes.constans';


@Component({
  selector: 'settlementdetail',
  templateUrl: './settlementdetail.component.html',
  styleUrls: ['../../assets/css/customer-list-table.css']
})

export class SettlementDetailComponent implements OnInit, OnDestroy {

  public customer_public_id: string;
  public customer_Account_settlement_public_id: string;

  excelExportData: any;
  ddlStatus: any[];



  displayedColumns: string[] = ['created', 'transaction.type', 'operation_list.reference', 'metadata.debtor', 'invoice.external_id', 'invoice.order_detail', 'description', 'order_name', 'total', 'fee_reference'];
  columnsToDisplay: string[] = this.displayedColumns.slice();
  dataSourceAccOperationSettlementList = new MatTableDataSource();
  selection = new SelectionModel<any>(true, []);
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  auth0Profile: any;

  isLoading = true;

  titleName: string;
  accountname: string;
  created: string;
  completedon: string;
  total: string;
  totalsymbol: string;
  totalNeto: string;
  totalNetosymbol: string;
  accountstatus: string;

  offsetTimeZone: any;
  offsetMinutes: any;
  offsetTimeVal: any;
  configurationDetails: any;
  versionConfigurationDetails: any;
  displayedColumnsV2: string[] = ['created', 'transaction.type', 'operation_list.reference', 'metadata.debtor', 'invoice.external_id', 'invoice.order_detail', 'description', 'order_name', 'credit', 'debit', 'fee_reference'];
  totalCredit: any;
  totalDebit: any;
  netTotal: any;
  export_templates = [];
  isExportTemplateAvailable = false;

  pageSize: number;
  PageSizeOptions: number[];
  customerStatus = 0;
  customerType = 0;
  searchValue = '';
  pageIndex: number = 0;
  pageStart: number = 0;
  totalSize: any;

  existSettlementProperties: boolean = false;
  timeCompleted: boolean = false;
  isExportDataAvailable: object | undefined;
  exportSubscription$ : Subscription;

  baseURL: string;
  timerId: any;
  isErrorExportAvailable: object | undefined;

  /** This is Constructor function which is used to initialize the class variables and objects; 
   */
  constructor
    (
      private router: Router
      , private excelService: ExcelService
      , private readonly activatedRoute: ActivatedRoute
      , private settlementProcessService: SettlementProcessService
      , private spinnerService: Ng4LoadingSpinnerService
      , private currencyPipe: CurrencyPipe
      , private excelDateConvertService:ExcelDateConvertService
    ) {
      this.pageSize = AppConfig.settings.gridPageSetting.PageSize;
      this.PageSizeOptions = AppConfig.settings.gridPageSetting.PageSizeOptions;
      this.baseURL = AppConfig.settings.apiServer.baseURL + BatchProcessUrls.URL_BATCHES_V1;
  }//end 




  /** This is ngOnInit function called after initialising the component; 
 */
  ngOnInit() {



    var browserStorage;
    let browserStorage1 = (localStorage.getItem('isCorporate') == 'undefined') ? null : localStorage;
    if (browserStorage1 == null) {
      browserStorage = localStorage.getItem('companyId');
      if (browserStorage == null || browserStorage == '' || browserStorage == undefined) {
        this.router.navigate(['/home']);
      }
      else {
        this.customer_public_id = localStorage.getItem('companyId');

      }
    }
    else {
      this.customer_public_id = localStorage.getItem('subcompanyId');

    }
    browserStorage = (typeof localStorage === 'undefined') ? null : localStorage;
    this.offsetTimeZone = (typeof browserStorage.getItem('timezone') === 'undefined') ? null : browserStorage.getItem('timezone');

    if (this.offsetTimeZone == null || this.offsetTimeZone === 'undefined' || Number.isNaN(this.offsetTimeZone)) {
      this.offsetTimeZone = -5.00;
      this.offsetMinutes = 0;
      this.offsetTimeVal = (this.offsetTimeZone * 3600000);

      AppConfig.settings.userSetting.defaultTimeZone = this.offsetTimeVal;
    }
    else {
      this.offsetTimeZone = browserStorage.getItem('timezone');
      this.offsetMinutes = 30;
      this.offsetTimeVal = (this.offsetTimeZone * 3600000);

      AppConfig.settings.userSetting.defaultTimeZone = this.offsetTimeVal;
    }
    this.getVersionConfigurationDetails();
    //used to retrieve the customer Account public id
    let params: any = this.activatedRoute.snapshot.params;
    this.customer_Account_settlement_public_id = params.id;
    this.spinnerService.show();
    this.GetAccountSettlementDetails(this.pageSize, this.pageStart);
    this.getConfigurationDetails();

  }//end ngOnInit

  ngOnDestroy() {

  }//end ngOnDestroy


  ngAfterViewInit() {
    this.dataSourceAccOperationSettlementList.sort = this.sort;
  }

  /** This function is used to get the Settlement detail from the service; 
 * it accepts the param settlement id
 */
  GetAccountSettlementDetails(limit: number, start: number) {

    var resobj: any;
    this.settlementProcessService.getSettlement(this.customer_Account_settlement_public_id, limit, start, '').subscribe(data => {
      this.created = data.created;

      if (typeof data.transfer != 'undefined' && data.transfer) {
        this.completedon = data.transfer.created;


      }

      if (typeof this.completedon != 'undefined' && this.completedon) {

        this.completedon = this.completedon;
      }

      this.total = data.gross_amount.value;
      this.totalsymbol = data.gross_amount.symbol;
      this.totalNeto = data.net_amount.value;
      this.totalNetosymbol = data.net_amount.symbol;
      
      if (data.settlement != undefined) {
        this.titleName = data.settlement.reference == undefined ? '' : data.settlement.reference;
        this.accountname = data.settlement.reference == undefined ? '' : data.settlement.reference;
      }
      this.accountstatus = data.status;
      if (this.accountstatus == 'NEW') {
        this.accountstatus = 'Pendiente';
      }
      if (this.accountstatus == 'CONFIRMED') {
        this.accountstatus = 'Confirmado';
      }
      if (this.accountstatus == 'COMPLETED') {
        this.accountstatus = 'Completado';
      }
      if (this.accountstatus == 'VOIDED') {
        this.accountstatus = 'Anulado';
      }

      this.totalCredit = data.total_credit_amount == undefined ? "" : data.total_credit_amount;
      this.totalDebit = data.total_debit_amount == undefined ? "" : data.total_debit_amount;
      this.netTotal = data.net_amount == undefined ? "" : data.net_amount;

      this.isLoading = false;

      let resources = data['operation_list'];
      this.excelExportData = resources;
      this.totalSize = data['records'];
      this.spinnerService.hide();
      this.dataSourceAccOperationSettlementList.data = resources;
    },
      error => {
          this.isLoading = false;
          console.log('Failed while trying to the Customer Search Result. ' + error);
      })
  }//end

  exportAsXLSX() {
    this.spinnerService.show();
    const exportLimit = (this.totalSize != undefined && this.totalSize != null && Number(this.totalSize) > 0)
      ? Number(this.totalSize)
      : 500000;

    this.settlementProcessService.getSettlement(this.customer_Account_settlement_public_id, exportLimit, 0, '').subscribe(data => {
      const fullExportData = data['operation_list'];

      if (this.versionConfigurationDetails != null && this.versionConfigurationDetails != undefined
        && this.versionConfigurationDetails.values.version == 'V2') {
        this.setExportExcelFileDataV2(fullExportData);
      } else {
        this.setExportExcelFileData(fullExportData);
      }

      this.spinnerService.hide();
    },
      error => {
        this.spinnerService.hide();
        console.log('Failed while trying to export the settlement detail. ' + error);
      });

  }//end

  setExportExcelFileDataV2(excelExportData) {
    var excelHeader = ["FECHA", "OPERACIÓN", "REFERENCIAL DE OPERACIÓN", "CLIENTE", "INVOICE ID", "REFERENCIA DE ORDEN", "DESCRIPCIÓN", "NOMBRE DE LA ORDEN", "CRÉDITOS", "DÉBITOS", "REFERENCIA"];
    var arrFinalData = [];
    var object_temp = {};
    var k = 0;
    var columnsKeyNames = [];
    for (k = 0; k < excelExportData.length; k++) {
      var singleRec_temp = excelExportData[k];
      columnsKeyNames = Object.keys(singleRec_temp);
      var created_temp;
      var transaction_temp = "";
      var reference_temp = "";
      var debtor_temp = "";
      var invoice_id_temp;
      var order_id_temp = "";
      var order_description_temp = "";
      var order_name_temp = "";
      var credit_temp = "";
      var debit_temp = "";
      var fee_reference_temp;

      for (var i = 0; i < columnsKeyNames.length; i++) {
        if (columnsKeyNames[i] == "created") {
          let createdate = this.excelDateConvertService.convertExcelDateTime(singleRec_temp[columnsKeyNames[i]]);
          created_temp = createdate;
        }

        if (columnsKeyNames[i] == "transaction") {
          var statusType = singleRec_temp[columnsKeyNames[i]].type;
          var type = singleRec_temp['type'];
          if ((statusType == "PAYMENT") && (type == "CREDIT")) {
            transaction_temp = 'Pago';
          } else if ((statusType == "SERVICE_FEE") && (type == "DEBIT")) {
            transaction_temp = 'Comisión';
          } else if ((statusType == "PAYMENT") && (type == "DEBIT")) {
            transaction_temp = 'Pago reverso';
          } else if ((statusType == "SERVICE_FEE") && (type == "CREDIT")) {
            transaction_temp = 'Comisión reversa';
          } else {
            transaction_temp = statusType;
          }

          if (singleRec_temp[columnsKeyNames[i]].total != undefined) {
            if (((statusType == "PAYMENT") && (type == "CREDIT")) || ((statusType == "SERVICE_FEE") && (type == "CREDIT"))) {
              credit_temp = this.currencyPipe.transform(singleRec_temp[columnsKeyNames[i]].total.value, "", "");
            } else {
              credit_temp = "";
            }

            if (((statusType == "PAYMENT") && (type == "DEBIT")) || ((statusType == "SERVICE_FEE") && (type == "DEBIT"))) {
              debit_temp = this.currencyPipe.transform(singleRec_temp[columnsKeyNames[i]].total.value, "", "");
            } else {
              debit_temp = "";
            }
          }
        }

        if (columnsKeyNames[i] == "reference") {
          reference_temp = singleRec_temp[columnsKeyNames[i]];
        }

        
        if (columnsKeyNames[i] == "metadata") {
          var transType = "";
          transType = singleRec_temp['transaction'].type;

          if (transType == 'PAYMENT') {
            if (columnsKeyNames[i] == "metadata") {
              var metadata_temp = singleRec_temp[columnsKeyNames[i]];
              debtor_temp = (metadata_temp.debtor && metadata_temp.debtor.name) ? metadata_temp.debtor.name : "";
              if (this.accountstatus == "Confirmado" && metadata_temp.invoice){
                invoice_id_temp = metadata_temp.invoice.external_id;
              }
              if (metadata_temp.invoice && metadata_temp.invoice.order_detail) {
                order_id_temp = metadata_temp.invoice.order_detail.order_id;
                order_description_temp = metadata_temp.invoice.order_detail.order_description;
                order_name_temp = metadata_temp.invoice.order_detail.order_name;
              }
            }
          } 
        }

        if (columnsKeyNames[i] == "fee_reference") {
          fee_reference_temp = singleRec_temp[columnsKeyNames[i]];
        }
      }
      arrFinalData.push([created_temp, transaction_temp, reference_temp, debtor_temp, invoice_id_temp, order_id_temp, order_description_temp, order_name_temp, credit_temp, debit_temp, fee_reference_temp]);
    }

    let createdDateTemp = this.excelDateConvertService.convertExcelDateTime(this.created);
    var createExport = createdDateTemp;
    var completeExport;
    if (typeof this.completedon != 'undefined' && this.completedon) {
      let completeddate = this.excelDateConvertService.convertExcelDateTime(this.completedon);
      completeExport = completeddate;
    }
    else {
      completeExport = "";
    }

    var totalCreditTemp = "";
    var totalDebitTemp = "";
    var totalNetTemp = "";
    if(this.totalCredit != undefined && this.totalCredit != null){
      if(this.totalCredit.value != undefined && this.totalCredit.value !=null){
        totalCreditTemp = this.totalCredit.value;
      }
    }

    if(this.totalDebit != undefined && this.totalDebit != null){
      if(this.totalDebit.value != undefined && this.totalDebit.value !=null){
        totalDebitTemp = this.totalDebit.value;
      }
    }

    if(this.netTotal != undefined && this.netTotal != null){
      if(this.netTotal.value != undefined && this.netTotal.value !=null){
        totalNetTemp = this.netTotal.value;
      }
    }

    this.excelService.generateSettlementViewExcel_V2(arrFinalData, excelHeader,this.accountname, createExport, completeExport, this.currencyPipe.transform(totalCreditTemp, "", ""), this.currencyPipe.transform(totalDebitTemp, "", ""), this.currencyPipe.transform(totalNetTemp, "", ""), this.accountstatus);
  }

  setExportExcelFileData(excelExportData) {

    var excelHeader = ["FECHA", "OPERACIÓN", "REFERENCIAL DE OPERACIÓN", "CLIENTE", "INVOICE ID", "REFERENCIA DE ORDEN", "DESCRIPCIÓN", "NOMBRE DE LA ORDEN", "TOTAL", "REFERENCIA"]

    var arrFinalData = [];
    var object_temp = {};
    var k = 0;
    var columnsKeyNames = [];

    for (k = 0; k < excelExportData.length; k++) {
      var singleRec_temp = excelExportData[k];
      
      columnsKeyNames = Object.keys(singleRec_temp);
      
      var created_temp;
      var transaction_temp;
      var reference_temp;
      var debtor_temp;
      var invoice_id_temp;
      var order_id_temp;
      var order_description_temp;
      var order_name_temp;
      var total_temp;
      var fee_reference_temp;

      var object_temp1 = {};
      var object_temp2 = {};
      var object_temp3 = {};
      var object_temp4 = {};
      var object_temp5 = {};
      var object_temp6 = {};

      object_temp = {};

      for (var i = 0; i < columnsKeyNames.length; i++) {
        if (columnsKeyNames[i] == "created") {

          // var tempCreatedDate = new Date(formatDate(singleRec_temp[columnsKeyNames[i]], 'yyyy-MM-dd hh:mm:ss', 'en-US'));
          let createdate = this.excelDateConvertService.convertExcelDateTime(singleRec_temp[columnsKeyNames[i]]);
          created_temp = createdate;
        }

        var statusType;
        if (columnsKeyNames[i] == "transaction") {
          statusType = singleRec_temp[columnsKeyNames[i]].type;
          switch (statusType) {
            case 'PAYMENT':
              transaction_temp = 'Pago'
              break;
            case 'SERVICE_FEE':
              transaction_temp = 'Comisión'
              break;
            default:
              transaction_temp = statusType;
          }
        }

        if (columnsKeyNames[i] == "reference") {
          reference_temp = singleRec_temp[columnsKeyNames[i]];
        }

        var transType;
        if (columnsKeyNames[i] == "metadata") {

          transType = singleRec_temp['transaction'].type;

          if (transType == 'PAYMENT') {
            if (columnsKeyNames[i] == "metadata") {
              var metadata_temp = singleRec_temp[columnsKeyNames[i]];
              debtor_temp = (metadata_temp.debtor && metadata_temp.debtor.name) ? metadata_temp.debtor.name : "";

              if (this.accountstatus == "Confirmado" && metadata_temp.invoice){
                invoice_id_temp = metadata_temp.invoice.external_id;
              }
              else{
                invoice_id_temp = ""
              }

              if (metadata_temp.invoice && metadata_temp.invoice.order_detail) {
                order_id_temp = metadata_temp.invoice.order_detail.order_id;
                order_description_temp = metadata_temp.invoice.order_detail.order_description;
                order_name_temp = metadata_temp.invoice.order_detail.order_name;
              }
            }
          } else {
            debtor_temp = "";
            invoice_id_temp = "";
            order_id_temp = "";
            order_description_temp = "";
            order_name_temp = "";
          }

        }

        if (columnsKeyNames[i] == "transaction") {
          if (singleRec_temp[columnsKeyNames[i]].total != undefined) {
            total_temp = singleRec_temp[columnsKeyNames[i]].total.value;
          }
          else {
            total_temp = "";
          }
        }

        if (columnsKeyNames[i] == "fee_reference") {
          fee_reference_temp = singleRec_temp[columnsKeyNames[i]];
        }
      }

      // for (var j = 0; j < excelHeader.length; j++) {

      //   if (excelHeader[j] == "FECHA") {

      //     object_temp = created_temp;


      //   }

      //   if (excelHeader[j] == "OPERACIÓN") {

      //     object_temp1 = transaction_temp;
      //   }

      //   if (excelHeader[j] == "REFERENCIAL DE OPERACIÓN") {
      //     object_temp2 = reference_temp;
      //   }

      //   if (excelHeader[j] == "CLIENTE") {
      //     object_temp3 = debtor_temp;
      //   }
      //   if (excelHeader[j] == "REFERENCIA DE ORDEN") {
      //     object_temp4 = order_id_temp;
      //   }
      //   if (excelHeader[j] == "DESCRIPCIÓN") {
      //     object_temp5 = order_name_temp;
      //   }
      //   if (excelHeader[j] == "TOTAL") {
      //     object_temp6 = this.currencyPipe.transform(total_temp, "", "");
      //   }


      // }


      arrFinalData.push([created_temp, transaction_temp, reference_temp, debtor_temp, invoice_id_temp, order_id_temp, order_description_temp ,order_name_temp, this.currencyPipe.transform(total_temp, "", ""), fee_reference_temp]);
    }

    // var tempCreatedDate1 = new Date(formatDate(this.created, 'yyyy-MM-dd hh:mm:ss', 'en-US'));
    let createdDateTemp = this.excelDateConvertService.convertExcelDateTime(this.created);
    var createExport = createdDateTemp;
    var completeExport;

    if (typeof this.completedon != 'undefined' && this.completedon) {

      // var tempCompleteddate = new Date(formatDate(this.completedon, 'yyyy-MM-dd hh:mm:ss', 'en-US'));
      let completeddate = this.excelDateConvertService.convertExcelDateTime(this.completedon);
      completeExport = completeddate;
    }
    else {
      completeExport = "";
    }

    this.excelService.generateSettlementDetailsExcel(arrFinalData, this.accountname, createExport, completeExport, this.currencyPipe.transform(this.total, "", ""), this.currencyPipe.transform(this.totalNeto, "", ""), this.accountstatus);

  }//end function

  //Convert GMT
  // convertGMTTime(tempstartDate) {
  //   if (this.offsetTimeZone > 0) {
  //     let date: any = new Date(tempstartDate);
  //     var dateTimeZoneDiff = new Date(date);
  //     dateTimeZoneDiff.setMilliseconds(Number(this.offsetTimeVal));
  //     let startDate = formatDate(dateTimeZoneDiff, 'yyyy-MM-dd HH:mm:ss', 'en-US');
  //     return startDate;
  //   }
  //   else {
  //     var tempConvertStartDate = new Date(tempstartDate.setHours(tempstartDate.getHours() - this.offsetTimeZone));
  //     var convertStartDate = new Date(tempConvertStartDate.setMinutes(tempConvertStartDate.getMinutes() - this.offsetMinutes));
  //     let startDate = formatDate(convertStartDate, 'yyyy-MM-dd HH:mm:ss', 'en-US');
  //     return startDate;
  //   }

  // }

  //Convert GMT Excel Export

  // convertExcelGMTTime(value) {
  //   var dateTimeZoneDiff = value.split(/[- :]/),
  //     dateFinal = new Date(dateTimeZoneDiff[0], dateTimeZoneDiff[1] - 1, dateTimeZoneDiff[2], dateTimeZoneDiff[3], dateTimeZoneDiff[4], dateTimeZoneDiff[5]);
  //   dateFinal.setMilliseconds(Number(this.offsetTimeVal));
  //   var dateString = moment(dateFinal).format('MM/DD/YYYY HH:mm:ss');
  //   var dateObj = new Date(dateString);
  //   var momentObj = moment(dateObj);
  //   var momentString = momentObj.format('DD/MM/YYYY HH:mm:ss'); // 2016-07
  //   return momentString;
  // }

  getConfigurationDetails() {
    this.settlementProcessService.getConfigurationDetails(this.customer_public_id).subscribe(data => {
      this.configurationDetails = data;
      if(this.configurationDetails != null && this.configurationDetails != undefined){
        if(this.configurationDetails.values.export_templates != null && this.configurationDetails.values.export_templates != undefined){
          // this.configurationDetails.values = {
          //     "export_template": "BCP2"
          // }
          if(Array.isArray(this.configurationDetails.values.export_templates)){
            this.isExportTemplateAvailable = true;
            this.export_templates = this.configurationDetails.values.export_templates;
          }

          if (this.configurationDetails.key) {
            if (this.configurationDetails.key === 'settlement.properties') {
              this.existSettlementProperties = true;
            }
          }
          
        }
      }
      
    },
      err => {
        console.log('Failed while trying to get configuration details.' + err.error);
      })
  }

  async getVersionConfigurationDetails() {
    try {
      const data = await this.settlementProcessService.getVersionConfigurationDetails(this.customer_public_id);
      this.versionConfigurationDetails = data;
      //this.versionConfigurationDetails.values.version = "V1";
    }
    catch (err) {
      console.log('Failed while trying to get version configuration details.' + err.error);
    }
  }

  checkResponseExportTime() {
    this.timerId = setTimeout(() => {
      if (this.isExportDataAvailable == undefined && this.isErrorExportAvailable == undefined) {
        this.spinnerService.hide();
        this.timeCompleted = true;
        this.exportSubscription$.unsubscribe();
      }
    }, 11000);
  }

  exportAsTXT() {
    this.spinnerService.show();
    clearTimeout(this.timerId);
    this.isExportDataAvailable = undefined;
    this.isErrorExportAvailable = undefined;

    if (this.configurationDetails.status == "ACTIVE") {
      let body = {
        "template": this.configurationDetails.values.export_template
      }
      this.checkResponseExportTime();
      this.exportSubscription$ = this.settlementProcessService.exportAsTXT(this.customer_Account_settlement_public_id, body).subscribe(data => {
        this.isExportDataAvailable = data;
        if (data.body.storage_url != undefined) {
          location.href = data.body.storage_url;
        } else {
          console.log(data.body);
        }
        this.spinnerService.hide();
      },
        err => {
          this.isErrorExportAvailable = err;
          console.log('Failed while trying to export txt file.' + err.error);
          this.spinnerService.hide();
        })
    }
  }

  exportTemplate(template: string) {
    this.spinnerService.show();
    clearTimeout(this.timerId);
    this.isExportDataAvailable = undefined;
    this.isErrorExportAvailable = undefined;

    if (this.configurationDetails.status == "ACTIVE") {
      let body = {
        "template": template
      };
      this.checkResponseExportTime();
      this.exportSubscription$ = this.settlementProcessService.exportAsTXT(this.customer_Account_settlement_public_id, body).subscribe(data => {

        this.isExportDataAvailable = data;

        if (data.body.storage_url != undefined) {
          location.href = data.body.storage_url;
        } else {
          console.log(data.body);
        }

        this.spinnerService.hide();
      }, err => {
          this.spinnerService.hide();
          this.isErrorExportAvailable = err;
          console.log('Failed while trying to export txt file.' + err.error);
      });
    }
  }

  closeModal() {
    this.timeCompleted = false;
  };

  pageEvent(event) {
    this.spinnerService.show();
    this.pageSize = event.pageSize;
    this.pageStart = event.pageIndex * event.pageSize;
    this.pageIndex = event.pageIndex;
    this.settlementProcessService.getSettlement(this.customer_Account_settlement_public_id, this.pageSize, this.pageStart, '').subscribe(data => {
        this.spinnerService.hide();
        let resources = data['operation_list'];
        this.totalSize = data['records'];            
        this.excelExportData = resources;
        this.dataSourceAccOperationSettlementList.data = resources;
    },
        error => {
          this.spinnerService.hide();
            console.log('Failed while trying to the Customer Search Result. ' + error);
        })
  }

  viewInvoice(id) {
    const application = localStorage.getItem('application');
    if (AccountTypeOptions[application] != undefined) {
      this.router.navigate([`/${AccountTypeOptions[application]}/invoices/${id}/view`]);
    }
  }
  
}//end class


